import {
    ReactNode,
    createContext,
    useContext,
    useEffect,
    useState
} from 'react'
import { getPmuBonus } from '../../services/firestore'
import { ITranslationContext, TLanguage } from './TranslationContext.types'
import { TRANSLATIONS } from './translations'

export const TranslationContext = createContext<ITranslationContext>({
    translations: TRANSLATIONS.fr(50),
    language: 'fr',
    setLanguage: () => {}
})

export const TranslationContextProvider = ({
    children
}: {
    children: ReactNode
}) => {
    const [language, setLanguage] = useState<TLanguage>('fr')
    const [bonus, setBonus] = useState<number>(50)

    useEffect(() => {
        getPmuBonus().then((fetchedBonus) => {
            if (fetchedBonus !== undefined) {
                setBonus(fetchedBonus)
            }
        })
    }, [])

    return (
        <TranslationContext.Provider
            value={{
                translations: TRANSLATIONS[language](bonus),

                language,
                setLanguage
            }}
        >
            {children}
        </TranslationContext.Provider>
    )
}

export const useTranslation = () => useContext(TranslationContext).translations
